const columns = [
  {
    name: 'City',
    selector: (row) => row.name,
  },
  {
    name: 'State',
    selector: (row) => row.state,
  },
  {
    name: 'Pincode',
    selector: (row) => row.pincode,
  },
  {
    name: 'Actions',
    selector: (row) => row.actions,
  },
]

export default columns
